<i18n>
{
	"en": {
		"orderTemplates": "order templates",
		"noTemplates": "There are no orders on this template yet",
		"customerName": "Customer",
		"eta": "ETA/ATA",
		"etd": "ETD/ATD",
		"from": "From",
		"loadingMeters": "Loading",
		"name": "Name",
		"numberOfPallets": "Pallets",
		"order": "Order",
		"status": "Status",
		"to": "To",
		"volume": "Volume",
		"weight": "Gr. Weight"
	},
	"no": {
		"orderTemplates": "oppdragsmaler",
		"noTemplates": "Det er ingen oppdrag på denne malen enda",
		"customerName": "Kunde",
		"eta": "ETA/ATA",
		"etd": "ETD/ATD",
		"from": "Fra",
		"name": "Navn",
		"loadingMeters": "Lastm.",
		"numberOfPallets": "Kolli",
		"order": "Oppdrag",
		"status": "Status",
		"to": "Til",
		"volume": "Vol",
		"weight": "Br. vekt"
	}
}
</i18n>
<template>
	<div class="cargo-information">
		<!-- <div class="cargo-information-header">
			TODO: Add this along with freightlines etc.
			<t-panel-header
				:text="`${templateCount} ${$t('orderTemplates')}`"
				icon="orders"
				size="md"
			/>
			<t-metric-details
				:value="templateDetails.volume"
				:max="Number(getProperty(templateDetails.cargoCarrier, 'volume'))"
				:label="$t('volume')"
				decimals="1"
				unit="m3"
			/>
			<t-metric-details
				:value="templateDetails.grossWeight"
				:max="Number(getProperty(templateDetails.cargoCarrier, 'weight'))"
				:label="$t('weight')"
				unit="kg"
			/>
			<t-metric-details
				:value="templateDetails.loadingMeters"
				:max="Number(getProperty(templateDetails.cargoCarrier, 'loadingMeters'))"
				:label="$t('loadingMeters')"
				decimals="1"
				unit="lm"
			/>
		</div> -->

		<t-grid
			v-if="templateCount"
			ref="grid"
			:columnDefinitions="columnDefinitions"
			:defaultColumnDefinition="defaultColumnDef"
			:rowHeight="50"
			:items="orderTemplates"
			:showFilters="false"
			class="menu-grid"
			selectable
			@delete="onGridDelete"
			@select="onRowsSelected"
		>
			<template #status="{ item }">
				<div class="order-icon-container">
					<t-timpex-icon
						:icon="getStatusIcon(item)"
						:color="getStatusColor(item)"
						size="md"
					/>
					<t-pill
						v-if="item.deviations"
						size="small"
						color="red"
						style="position: absolute; top: -25%; right: 0;"
						isSolid
					>!</t-pill>
				</div>
			</template>
			<template #despatchParty="{ item }">
				<div style="height: 16px;">{{ item.despatchParty.name }}</div>
				<div class="grid-cell-sub-line">{{ item.despatchParty.street }}, {{ item.despatchParty.postalCode }} {{ item.despatchParty.postalPlace }}</div>
			</template>
			<template #deliveryParty="{ item }">
				<div style="height: 16px;">{{ item.deliveryParty.name }}</div>
				<div class="grid-cell-sub-line">{{ item.deliveryParty.street }}, {{ item.deliveryParty.postalCode }} {{ item.deliveryParty.postalPlace }}</div>
			</template>
			<template #customer="{ item }">
				<div v-if="item.customer" style="height: 16px;">{{ item.customer.name }}</div>
				<div v-if="item.customer" class="grid-cell-sub-line">{{ item.customer.customerNo }}</div>
			</template>
			<template #removeTemplate="{ item }">
				<t-icon-button
					icon="trash"
					intent="danger"
					type="bp"
					appearance="minimal"
					@click="removeOrderTemplate(item.id)"
				/>
			</template>
		</t-grid>

		<t-no-content-panel
			v-else
			:text="$t('noTemplates')"
			icon="order"
			style="height: 500px;"
		/>
	</div>
</template>

<script>
import { goodsTypesIcons, statuses } from '@/core';
import { mapState, mapActions } from '../store/tripTemplates.store';
export default {
	name: 'OrdersOnTemplate',
	data() {
		return { defaultColumnDef: { resizable: true } };
	},
	computed: {
		...mapState(['templateDetails']),
		templateCount() {
			return this.templateDetails.orderTemplateBindings.length;
		},
		orderTemplates() {
			return this.templateDetails.orderTemplateBindings.map(otb => otb.orderTemplate);
		},
		columnDefinitions() {
			return [
				{
					field: 'name',
					displayName: this.$t('name'),
					valueGetter: ({ name }) => name,
					width: 75
				},
				{
					field: 'status',
					displayName: this.$t('status'),
					valueGetter: ({ status }) => status,
					width: 50,
					center: true,
				},
				{
					field: 'despatchParty',
					displayName: this.$t('from'),
					comparableValueGetter: ({ despatchParty }) => this.addressGetter(despatchParty),
					minWidth: 125,
				},
				{
					field: 'deliveryParty',
					displayName: this.$t('to'),
					comparableValueGetter: ({ deliveryParty }) => this.addressGetter(deliveryParty),
					minWidth: 125,
				},
				{
					field: 'customer',
					displayName: this.$t('customerName'),
					comparableValueGetter: ({ customer }) => customer ? `${customer.name} ${customer.customerNo}` : '',
					minWidth: 125,
					type: 'customer',
				},
				{
					field: 'removeTemplate',
					displayName: '',
					width: 50,
					filterable: false,
					resizable: false,
					align: 'center'
				}
			];
		}
	},
	methods: {
		...mapActions(['setOrderTemplateBindings']),
		onRowsSelected(ids) {
			this.rowsSelected = ids.length;
		},
		getProperty(object, propKey) {
			if (!object) return undefined;
			return object[propKey];
		},
		getStatusIcon({ goodsType }) {
			return goodsTypesIcons(goodsType);
		},
		getStatusColor({ status }) {
			return statuses.color(status);
		},
		addressGetter(party) {
			if (!party) return '';
			return `${party.name} ${party.street} ${party.postalCode} ${party.postalPlace}`;
		},
		onGridDelete() {
			let selectedIds = this.$refs.grid.getSelectedItems().map( (x) => x.id );
			for (let id of selectedIds) {
				this.removeOrderTemplate(id);
			}
			this.$refs.grid.resetSelectedRows();
		},
		removeOrderTemplate(id) {
			let orderTemplateBindings = [];
			if (id) {
				orderTemplateBindings = this.templateDetails.orderTemplateBindings.filter( (templateBinding) => templateBinding.orderId !== id );
			}
			this.setOrderTemplateBindings(orderTemplateBindings);
		}
	}
};
</script>

<style>
.cargo-information {
	height: 500px;
}

.cargo-information-header {
	display:grid;
	padding: 15px;
	grid-template-columns: auto repeat(3, max-content);
	grid-column-gap: 20px;
	background: white;
}

.menu-grid {
	margin-top: 20px;
	height: calc(100% - 54px);
	width: 100%;
}

.order-icon-container {
	position: relative;
	width: 100%;
	display: flex;
	justify-content: center;
}
</style>
